import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SortAlpDescIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SortAlpDesc",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.19 23.74h-2.41V2.88c0-.48-.39-.88-.88-.88H8.15c-.48 0-.88.39-.88.88v20.87H4.84c-1.15 0-1.43.67-.61 1.48l4.8 4.78 4.79-4.79c.8-.81.53-1.47-.63-1.47Zm3.96-11.45 6.66-8.37h-6.55V2h9.15v1.99l-6.7 8.34h6.83v1.92h-9.39zm3.95 5.46h1.89L28.24 30h-2.47l-1.14-2.8h-5.32l-1.1 2.8h-2.44zm2.76 7.58-1.88-4.95-1.92 4.98z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.57 27.89c-.63 0-1.14-.51-1.14-1.14V6.17a1.14 1.14 0 1 1 2.28 0v20.57c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.57 27.89c-.3 0-.59-.12-.81-.33l-4.57-4.57a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l3.76 3.76 3.76-3.76a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.57 4.57c-.21.21-.5.33-.81.33M22.17 18.95h2.67l3.31 8.94h-2.4l-.51-1.51h-3.46l-.51 1.51h-2.4l3.31-8.94Zm2.42 5.54-1.08-3.24-1.1 3.24zM19.82 12.33l3.88-5.27h-3.65V5.01h6.79v1.6l-3.92 5.28h4.06v2.06h-7.16v-1.61Z"
      })]
    })
  }));
};